(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["signora-standard"] && !Shopify.designMode) return;
  try {
    
(function () {
  function enhanceProof(root) {
    var proof = root.querySelector('[data-ss-proof]');
    if (!proof || proof.dataset.ssProofEnhanced === 'true') return;
    var buttons = Array.prototype.slice.call(proof.querySelectorAll('[data-ss-choice]'));
    var panels = Array.prototype.slice.call(proof.querySelectorAll('[data-ss-result]'));
    if (!buttons.length || !panels.length) return;
    proof.dataset.ssProofEnhanced = 'true';
    proof.classList.add('is-enhanced');

    function select(value, moveFocus) {
      buttons.forEach(function (button) {
        var active = button.dataset.ssChoice === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && moveFocus) button.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.ssResult === value;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        select(button.dataset.ssChoice, false);
      });
      button.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        select(buttons[nextIndex].dataset.ssChoice, true);
      });
    });

    var initial = buttons.filter(function (button) { return button.getAttribute('aria-pressed') === 'true'; })[0] || buttons[0];
    select(initial.dataset.ssChoice, false);
  }

  function enhance(root) {
    if (!root || root.dataset.ssEnhanced === 'true') return;
    root.dataset.ssEnhanced = 'true';
    enhanceProof(root);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    if (!items.length || reduced || !('IntersectionObserver' in window)) return;
    root.classList.add('ss-motion');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (item) { observer.observe(item); });
    window.setTimeout(function () {
      items.forEach(function (item) { item.classList.add('is-visible'); });
    }, 2400);
  }

  function boot(scope) {
    var root = scope && scope.matches && scope.matches('.ss-page') ? scope : document.querySelector('.ss-page');
    enhance(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjw-care-composition"] && !Shopify.designMode) return;
  try {
    
  function initializeCareAccordions(scope) {
    scope.querySelectorAll('.sjw-care__panel').forEach(function (panel) {
      if (panel.dataset.singleOpenReady === 'true') return;

      panel.dataset.singleOpenReady = 'true';
      var items = panel.querySelectorAll('.sjw-care__item');

      items.forEach(function (item) {
        item.open = false;

        item.addEventListener('toggle', function () {
          if (!item.open) return;

          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.open) {
              otherItem.open = false;
            }
          });
        });
      });
    });
  }

  initializeCareAccordions(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeCareAccordions(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjw-collection-guide"] && !Shopify.designMode) return;
  try {
    
  function initializeSjwGuideMotion(scope) {
    var motifs = [
      '<svg viewBox="0 0 64 64" focusable="false"><circle class="sjw-cg-motion__soft sjw-cg-motion__orbit" cx="32" cy="32" r="25" stroke-dasharray="2 7"></circle><path class="sjw-cg-motion__line sjw-cg-motion__draw" d="M32 16 43 27 32 47 21 27 32 16Zm-11 11h22M32 16l-5 11 5 20 5-20-5-11Z"></path><path class="sjw-cg-motion__line sjw-cg-motion__glint" d="M49 11v8m-4-4h8"></path></svg>',
      '<svg viewBox="0 0 64 64" focusable="false"><path class="sjw-cg-motion__soft sjw-cg-motion__orbit" d="M11 32a21 21 0 1 0 42 0 21 21 0 1 0-42 0" stroke-dasharray="1 9"></path><path class="sjw-cg-motion__line sjw-cg-motion__draw" d="m32 11 19 17-19 25-19-25 19-17Zm-19 17h38M32 11l-8 17 8 25 8-25-8-17ZM24 28l8-8 8 8"></path><path class="sjw-cg-motion__line sjw-cg-motion__glint" d="M13 12v7m-3.5-3.5h7"></path></svg>',
      '<svg viewBox="0 0 64 64" focusable="false"><circle class="sjw-cg-motion__line sjw-cg-motion__draw" cx="25" cy="35" r="15"></circle><circle class="sjw-cg-motion__line sjw-cg-motion__draw" cx="39" cy="35" r="15"></circle><path class="sjw-cg-motion__soft sjw-cg-motion__orbit" d="M32 7a25 25 0 0 1 25 25" stroke-dasharray="2 6"></path><path class="sjw-cg-motion__line sjw-cg-motion__glint" d="m32 14 5 5-5 8-5-8 5-5Zm18-3v8m-4-4h8"></path></svg>'
    ];

    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-motion-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.28 }) : null;

    scope.querySelectorAll('.sjw-cg-grid').forEach(function (grid) {
      grid.querySelectorAll('.sjw-cg-block').forEach(function (card, index) {
        if (!card.querySelector('.sjw-cg-motion')) {
          var motion = document.createElement('span');
          motion.className = 'sjw-cg-motion sjw-cg-motion--' + ((index % motifs.length) + 1);
          motion.setAttribute('aria-hidden', 'true');
          motion.innerHTML = motifs[index % motifs.length];
          card.prepend(motion);
        }

        if (observer) {
          observer.observe(card);
        } else {
          card.classList.add('is-motion-visible');
        }
      });
    });
  }

  initializeSjwGuideMotion(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeSjwGuideMotion(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjw-collection-list"] && !Shopify.designMode) return;
  try {
    
(function(){
  function revealIn(root){
    var cards = root.querySelectorAll('.sjwcl-card,.sjwcl-slat');
    if(!cards.length) return;
    if((window.Shopify && Shopify.designMode) || root.classList.contains('sjwcl--noanim') || !('IntersectionObserver' in window)){
      for(var i=0;i<cards.length;i++){ cards[i].classList.add('in'); }
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    for(var j=0;j<cards.length;j++){ io.observe(cards[j]); }
  }
  function init(){
    var roots = document.querySelectorAll('.sjwcl');
    for(var i=0;i<roots.length;i++){ if(roots[i].__sjwcl) continue; roots[i].__sjwcl = 1; revealIn(roots[i]); }
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sjw-featured-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){
    var cols = root.querySelectorAll('.sjwfp-col');
    if(!cols.length) return;
    if((window.Shopify && Shopify.designMode) || root.classList.contains('sjwfp--noanim') || !('IntersectionObserver' in window)){
      for(var i=0;i<cols.length;i++){ cols[i].classList.add('in'); } return;
    }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:0.1, rootMargin:'0px 0px -40px 0px'});
    for(var j=0;j<cols.length;j++){ io.observe(cols[j]); }
  }
  function carousel(root){
    var track = root.querySelector('.sjwfp-track'); if(!track) return;
    function step(){ var c = track.querySelector('.sjwfp-col'); var g = parseInt(getComputedStyle(track).columnGap)||14; return c ? c.getBoundingClientRect().width + g : 320; }
    var prev = root.querySelector('.sjwfp-prev'), next = root.querySelector('.sjwfp-next');
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    if(track.getAttribute('data-autoplay') === 'true' && !(window.Shopify && Shopify.designMode)){
      var sp = (parseFloat(track.getAttribute('data-speed'))||4) * 1000, timer=null, paused=false;
      function tick(){ if(paused) return; if(track.scrollLeft + track.clientWidth >= track.scrollWidth - 4){ track.scrollTo({left:0, behavior:'smooth'}); } else { track.scrollBy({left:step(), behavior:'smooth'}); } }
      function start(){ timer = setInterval(tick, sp); }
      ['mouseenter','focusin','pointerdown'].forEach(function(ev){ track.addEventListener(ev, function(){ paused=true; }); });
      ['mouseleave','focusout'].forEach(function(ev){ track.addEventListener(ev, function(){ paused=false; }); });
      start();
    }
  }
  function init(){
    var roots = document.querySelectorAll('.sjwfp');
    for(var i=0;i<roots.length;i++){ var r=roots[i]; if(r.__sjwfp) continue; r.__sjwfp=1; reveal(r); carousel(r); }
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
